function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34.016 34.016"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.prefix__a{fill:#daf0ed}.prefix__b{fill:#828a90}')), /*#__PURE__*/React.createElement("title", null, 'unpublish copy 2'), /*#__PURE__*/React.createElement("path", {
  className: "prefix__a",
  d: "M29.863 10.358v13.78a171.868 171.868 0 00-25.712 0v-13.78a171.868 171.868 0 0125.712 0zM4.151 24.138l-.109.009"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M4.185 10.991q6.437-.485 12.892-.483a.629.629 0 000-1.258q-6.45 0-12.892.475c-.813.062-.815 1.328 0 1.266zM17.077 23.044a118 118 0 00-13.033.571c-.688.078-.689 1.1 0 1.071 4.334-.175 8.687-.411 13.033-.408a.617.617 0 000-1.234z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M29.864 23.521q-6.384-.477-12.787-.477a.617.617 0 000 1.234q6.4 0 12.787.486c.8.061.8-1.182 0-1.243zM29.864 10.986c.8.061.8-1.189 0-1.25s-.8 1.191 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M17.077 10.508q6.4 0 12.787.478c.8.061.8-1.188 0-1.25q-6.384-.482-12.787-.486a.629.629 0 000 1.258zM29.244 20.1v4c0 .793 1.232.887 1.233.093v-4c0-.8-1.242-.895-1.241-.093z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M29.244 14.931V20.1c0 .8 1.24.892 1.241.093v-5.169c0-.8-1.241-.895-1.241-.093z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M29.24 10.315v4.616c0 .8 1.24.892 1.241.093v-4.615c0-.806-1.249-.9-1.248-.094zM3.531 20.2v4c0 .793 1.232.7 1.233-.093v-4c0-.8-1.242-.709-1.241.093z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M3.531 15.024V20.2c0 .8 1.241.706 1.241-.093v-5.176c0-.8-1.241-.709-1.241.093z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M3.527 10.409v4.615c0 .8 1.24.706 1.241-.093v-4.616c0-.806-1.25-.713-1.249.094zM14.379 17.065a3.269 3.269 0 012.33-3.3 3.312 3.312 0 014.144 2.507c.87 4.227-6.246 5.25-6.479.793a.625.625 0 00-1.249.027 4.4 4.4 0 005.182 4.2 4.481 4.481 0 003.842-4.858 4.529 4.529 0 00-9.028.663c-.021.803 1.233.775 1.258-.032z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.359 17.1a4.178 4.178 0 014.234-4.452 4.164 4.164 0 11.218 8.324c-2.727-.007-4.452-1.48-4.452-3.872z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M13.988 17.09A3.668 3.668 0 0116.6 13.4a3.708 3.708 0 014.634 2.8c.967 4.663-7 5.77-7.25.889a.625.625 0 00-1.249.03c.262 6.353 10.562 5.511 9.8-.729a4.951 4.951 0 00-5.435-4.348c-2.692.237-4.292 2.5-4.369 5.078-.024.809 1.233.78 1.257-.03z"
}));

export default SvgComponent;